import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Globe, CheckCircle2, AlertTriangle } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { loadSiteUrl } from "@/lib/site";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Section } from "@/components/settings/Section";

export function SiteAddress() {
  const [s, setS] = useState(null);
  const [value, setValue] = useState("");
  useEffect(() => {
    api.get("/owner/site-settings", { params: { origin: window.location.origin } }).then((r) => { setS(r.data); setValue(r.data.public_url || ""); });
  }, []);
  const save = async (v) => {
    try {
      const r = await api.put("/owner/site-settings", { public_url: v });
      setS(r.data); setValue(r.data.public_url || ""); loadSiteUrl();
      toast.success(v ? "Live address saved. All new links use it." : "Live address cleared");
    } catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  };
  if (!s) return null;
  return (
    <Section title="Live website address" desc="Every email link, client portal link and portfolio link uses this address." testId="site-address-card"
      right={<Globe className="h-5 w-5 text-indigo-600 dark:text-indigo-400" />}>
      <div className={`flex items-start gap-2 rounded-lg border p-3 text-sm mb-4 ${s.is_preview ? "border-amber-500/40 bg-amber-500/5" : "border-emerald-500/40 bg-emerald-500/5"}`} data-testid="site-address-status">
        {s.is_preview ? <AlertTriangle className="h-4 w-4 text-amber-600 mt-0.5" /> : <CheckCircle2 className="h-4 w-4 text-emerald-600 dark:text-emerald-400 mt-0.5" />}
        <div>
          Links currently point to <span className="font-semibold break-all" data-testid="site-effective-url">{s.effective_url}</span>
          <div className="text-xs text-muted-foreground mt-0.5">
            {s.is_preview ? "That's the preview address. After you publish, just open ScopeGuard on your live site while signed in — it's detected automatically. Or type it below." : "Your live address is set. Nothing else to do."}
          </div>
        </div>
      </div>
      <div className="flex gap-2 flex-wrap">
        <Input data-testid="site-url-input" value={value} onChange={(e) => setValue(e.target.value)} placeholder="https://your-site.com" className="flex-1 min-w-[220px]" />
        <Button data-testid="site-url-save-btn" onClick={() => save(value)} className="bg-indigo-600 hover:bg-indigo-500 text-white">Save address</Button>
        {s.public_url && <Button variant="ghost" data-testid="site-url-clear-btn" onClick={() => save("")}>Clear</Button>}
      </div>
    </Section>
  );
}
